import { CalendarEventGuestNotification } from '@griply/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from 'shared/components/ui/button';
import { ChoiceDialog } from 'shared/dialogs/choice';

export type EventNotifyGuestsDialogProps = {
  onSelect: (guestNotification: CalendarEventGuestNotification) => void;
  onClose: () => void;
};

export const EventNotifyGuestsDialog: React.FC<
  EventNotifyGuestsDialogProps
> = ({ onSelect, onClose }) => {
  const { t } = useTranslation();

  const onSend = () => onSelect(CalendarEventGuestNotification.All);
  const onDontSend = () => onSelect(CalendarEventGuestNotification.None);

  return (
    <ChoiceDialog
      open
      abovePopups
      // Neither answer destroys anything — the guests' calendars update either way.
      actionColor={Colors.Primary}
      title={t('forms.event.notify-guests.title')}
      message={t('forms.event.notify-guests.description')}
      primaryLabel={t('forms.event.notify-guests.send')}
      secondaryLabel={t('forms.event.notify-guests.dont-send')}
      onPrimary={onSend}
      onSecondary={onDontSend}
      onCancel={onClose}
    />
  );
};
